<style>
.th-wrap {
    justify-content: center;
}
</style>
<template>
    <div style="padding: 1rem 3rem;">
        <p class="title is-3-desktop is-4-tablet is-5-mobile">
            Importar Base de Datos
        </p>
        <p class="title" style="font-size: 1.2rem;">Importar Base de Datos de cajas/materiales enviados</p>

        <section>
            <div class="block">
                <a @click="showModalImport" class="button is-info">Cargar BD</a>
            </div>
        </section>
        <br>

        <b-field>
            <b-input placeholder="Ingresa número de orden..." v-model="textSearch" expanded type="search" icon="magnify">
            </b-input>
            <p class="control">
                <button @click="searchOrder" class="button is-info">Buscar</button>
                <button @click="cargarPedidos" class="button is-info"><b-icon size="is-mediun"
                        icon="reload"></b-icon></button>
            </p>
        </b-field>

        <section style="margin-top: 30px">
            <b-table :data="pedidoList" :hoverable="true" :mobile-cards="true" :opened-detailed="defaultOpenedDetails"
                detail-key="id" paginated backend-pagination :total="total" :per-page="searchOptions.perPage"
                :default-sort-direction="defaultSortOrder"
                :default-sort="[searchOptions.sortField, searchOptions.sortOrder]">

                <template slot-scope="props">
                    <b-table-column label="Tipo" class="is-size-7 has-text-centered">
                        {{ props.row.type | OrderGeneralType }}
                    </b-table-column>
                    <b-table-column label="Total Cajas" class="is-size-7 has-text-centered">
                        {{ props.row.total }}
                    </b-table-column>
                    <b-table-column label="Nro Orden" class="is-size-7 has-text-centered">
                        {{ props.row.numberOrder }}
                    </b-table-column>
                    <b-table-column field="orderDate" sortable label="Fecha Solicitud" class="is-size-7 has-text-centered">
                        {{ new Date(props.row.orderDate) | moment("DD-MM-YYYY - h:mm a") }}
                    </b-table-column>
                    <b-table-column field="deliveryDate" sortable label="Fecha Entrega" class="is-size-7 has-text-centered">
                        {{ new Date(props.row.deliveryDate) | moment("DD-MM-YYYY - h:mm a") }}
                    </b-table-column>
                    <b-table-column label="Estado" class="is-size-7 has-text-centered">
                        <b-tag :type="getClassStatusOrder(props.row.order_content)">{{ props.row.order_content |
                            StatusImport
                        }}</b-tag>
                    </b-table-column>
                    <b-table-column label="Acciones" centered>
                        <b-tooltip v-if="props.row.order_content != 'proc'" type="is-dark" label="Importar datos"
                            position="is-left">
                            <button @click="showModalImport(props.row)" class="button is-small"><b-icon type="is-info"
                                    size="is-mediun" icon="import"></b-icon></button>
                        </b-tooltip>
                        <!-- <b-tooltip v-if="props.row.order_content == 'proc'" type="is-dark"
                            label="Confirmar subida de archivo" position="is-left">
                            <button @click="processCheckIn(props.row)" class="button is-small"><b-icon type="is-info"
                                    size="is-mediun" icon="rocket"></b-icon></button>
                        </b-tooltip> -->
                        <b-tooltip v-if="props.row.order_content == 'proc'" type="is-dark" label="Proceso culminado"
                            position="is-left">
                            <button class="button is-small"><b-icon type="is-info" size="is-mediun"
                                    icon="check-circle"></b-icon></button>
                        </b-tooltip>
                    </b-table-column>
                </template>

                <template slot="detail" slot-scope="props">
                    <article class="media">
                        <div class="media-content">
                            <div class="content">
                                <h3 class="title is-5">Info</h3>

                                <a v-if="props.row.importFile" @click="goDownloadImport(props.row.importFile)">
                                    <b-tag type="is-success">
                                        <b-icon :icon="getIconFromExt(props.row.importFile.ext)" size="is-small">
                                        </b-icon>
                                        <span>
                                            {{ props.row.importFile.orgininalFileName }} ({{
                                                props.row.importFile.size | FileSize
                                            }})
                                        </span>
                                    </b-tag>
                                </a>
                            </div>
                        </div>
                    </article>
                </template>

                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>
                                <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                            </p>
                            <p>Ninguna Orden a Importar.</p>
                        </div>
                    </section>
                </template>

            </b-table>
        </section>

    </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from "vuex";
import Util from '../../util'

const importMaterial = () => import("../../components/imports/importMaterial");

export default {
    props: ["address"],

    data() {
        return {
            pedidoList: [],
            defaultOpenedDetails: [1],
            total: 0,
            searchOptions: { perPage: 10, pageNumber: 1, sortField: 'orderDate', sortOrder: 'desc' },
            defaultSortOrder: 'desc',
            radioStatus: "all",
            textSearch: "",
            CheckInSearch: false,
        };
    },
    methods: {
        ...mapActions({
            'loadOrderGeneral': 'orderGeneral/loadOrderGeneral',
            'downloadAttached': "files/downloadAttached",
            "getFileMaterial": "imports/getFileMaterial",
            "checkInImport": "imports/confirmImport",
        }),

        showModalImport(data) {
            this.$modal.open({
                parent: this,
                component: importMaterial,
                hasModalCard: true,
                props: {
                    client: Util.getAuth(),
                    order: data,
                    cargarPedidos: this.cargarPedidos
                }
            });
        },

        cargarPedidos() {
            let payload = null
            payload = { context: this, idClient: Util.getAuth().idClient }
            this.loadOrderGeneral(payload).then(data => {
                this.pedidoList = data.filter(item => item.status == 'recep');
                this.textSearch = "";
                this.CheckInSearch = false;
            }).catch((error) => {
                this.pedidoList = []
                this.total = 0
                this.textSearch = "";
            })
        },

        getClassStatusOrder(value) {
            if (value == null) return 'is-warning'
            if (value === 'upinit')
                return 'is-info'
            else if (value === 'proc')
                return 'is-success'
        },

        getIconFromExt(ext) {
            if (ext.toString().toLowerCase() == "pdf") return "file-pdf";
            if (
                ext.toString().toLowerCase() == "doc" ||
                ext.toString().toLowerCase() == "docx"
            )
                return "file-word";
            if (
                ext.toString().toLowerCase() == "jpg" ||
                ext.toString().toLowerCase() == "png"
            )
                return "image-area";
            if (ext.toString().toLowerCase() == "zip") return "zip-box";
            else return "file-cloud";
        },

        searchOrder() {
            if (this.textSearch != '') {
                this.pedidoList.some(element => {
                    if (element.numberOrder == this.textSearch) {
                        this.pedidoList = [element];
                        this.textSearch = "";
                        this.CheckInSearch = false;
                        return true;
                    } else {
                        this.CheckInSearch = true;
                    }
                });
            } else {
                this.CheckInSearch = false;
                this.textSearch = "";
                this.$dialog.confirm({
                    title: 'Advertencia',
                    message: `Ingrese un número de Orden`,
                    confirmText: "Entendido",
                    type: 'is-warning',
                    hasIcon: true,
                })
            }
            if (this.CheckInSearch) {
                this.textSearch = "";
                this.$dialog.confirm({
                    title: 'Advertencia',
                    message: `El N° de orden que busca no ha finalizado el proceso o ha ingresado un N° de orden incorrecto`,
                    confirmText: "Entendido",
                    type: 'is-warning',
                    hasIcon: true,
                })
            }
        },

        processCheckIn(value) {
            let payload = null
            payload = { context: this, idOrderGeneral: value.id }
            this.getFileMaterial(payload).then(data => {
                console.log(data);
                // this.checkInImport().then(resp => {
                    
                // }).catch((e) => {
                //     console.log(e);
                // })
            }).catch((error) => {
                console.log(error);
            })
        },

    },

    computed: {
    },

    filters: {
        OrderGeneralType: function (type) {
            if (type == 'BOX') return 'Cajas'
            if (type == 'BOX_MEDIOS') return 'Caja Medios'
            if (type == 'BOX_PLANOS') return 'Caja Planos'
            if (type == 'BOX_MUESTRAS') return 'Caja Muestras'
            return 'Error'
        },
    },

    mounted() {
        this.cargarPedidos();
    },

    created() {
    }
};
</script>
  



// WEBPACK FOOTER //
// src/components/pedido/ImportBd.vue